module.exports = __webpack_public_path__ + "img/covid-19.c2a9032d.jpg";